import React, { useEffect, useState } from "react";
import { Card, Row, Col, CardBody, Container, Button } from "reactstrap";
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import Navigator from "src/components/Navigator";
import axios from "axios";
import {
    API_URL_GET_E_LEARNING_LESSONS,
} from "../../common/constants";
import paginationFactory, {
    PaginationListStandalone,
    PaginationProvider,
    SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import { Link } from "react-router-dom";

import UserUtils from "../../services/utils/UserUtils";
import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";

const ElearningHome = ({
    t,
    user,
    token,
    modules,
    lng
}) => {
    const userUtils = new UserUtils();
    const [ userRole, setUserRole ] = useState();

    const columns = [
        {
            dataField: "lesson_name",
            text: t("Lesson name"),
            sort: true
        },
        {
            dataField: "language",
            text: t("Language"),
            sort: true
        },
        {
            dataField: "see_details",
            text: t("See details"),
            formatter: (cellContent, { lesson_id, lesson_name }) => {
                return (
                    <Link
                        to={{
                            pathname: `/${userRole}/e-learning/${lesson_id}/detail`,
                            lesson_id: lesson_id,
                            lesson_name: lesson_name,
                        }}
                    >
                        <Button
                            type="button"
                            color="btn btn-primary"
                            className="btn-rounded mb-2 me-2"
                        >
                            {t("Play")}
                        </Button>
                    </Link>
                )
            },
            sort: false
        }
    ];

    const handleFetchELearnings = useQuery({
        queryKey: [
            "fetch-e-learnings-query",
            lng,
            modules.active
        ],
        queryFn: async () => {
            const response = await axios.post(
                API_URL_GET_E_LEARNING_LESSONS,
                { 
                    module: modules.active 
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            return response.data?.message || null;
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        onError: () => {
            toast(t("An error occurred while fetching the E-Learning list."), {
                type: "error"
            });
        }
    });

    useEffect(() => {
        if (userUtils.isAnalystAdmin(user)) {
            setUserRole('admin')
        } 
        else if (userUtils.isEmployee(user)) {
            setUserRole('employee')
        } 
        else if (userUtils.isThirdParty(user)) {
            setUserRole('third-party')
        }
    }, [ user ]);

    return (
        <div className="page-content">
            <Container fluid>
                <Row>
                    <Col lg="12" className="mb-4">
                        <Navigator
                            pageTitle="E-Learning"
                            breadCrumbs={[
                                { title: "SIP", link: "/" },
                                { title: "E-Learning", link: "#" },
                            ]}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col className="col-12">
                        <Card>
                            <CardBody>
                                <PaginationProvider
                                    pagination={paginationFactory({
                                        sizePerPage: 25,
                                        totalSize: handleFetchELearnings.data?.length || 0,
                                        custom: true
                                    })}
                                    keyField="lesson_id"
                                    columns={columns}
                                    data={handleFetchELearnings.data || []}
                                >
                                    {({ paginationProps, paginationTableProps }) => (
                                        <ToolkitProvider
                                            keyField="lesson_id"
                                            columns={columns}
                                            data={handleFetchELearnings.data || []}
                                            search
                                        >
                                            {(toolkitProps) => (
                                                <React.Fragment>
                                                    <Row>
                                                        <Col xl="12">
                                                            <div className="table-responsive">
                                                                <BootstrapTable
                                                                    keyField={"lesson_id"}
                                                                    responsive
                                                                    bordered={false}
                                                                    striped={false}
                                                                    defaultSorted={[]}
                                                                    classes={
                                                                        "table align-middle table-nowrap"
                                                                    }
                                                                    headerWrapperClasses={"thead-light"}
                                                                    {...toolkitProps.baseProps}
                                                                    {...paginationTableProps}
                                                                />
                                                            </div>
                                                        </Col>
                                                    </Row>

                                                    <Row className="align-items-md-center mt-30">
                                                        <Col className="inner-custom-pagination d-flex">
                                                            <div className="d-inline">
                                                                <SizePerPageDropdownStandalone
                                                                    {...paginationProps}
                                                                />
                                                            </div>
                                                            <div className="text-md-right ms-auto">
                                                                <PaginationListStandalone
                                                                    {...paginationProps}
                                                                />
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </React.Fragment>
                                            )}
                                        </ToolkitProvider>
                                    )}
                                </PaginationProvider>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

const mapStatetoProps = (state) => {
    const { user, token } = state.Login;
    const { Modules } = state;
    return { 
        token, 
        user, 
        modules: Modules 
    };
};

export default withNamespaces()(
    connect(mapStatetoProps, null)(
        ElearningHome
    )
);
